import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button
} from '@mui/material';

export const ConfirmDialog = ({ open, onClose, title, content, onConfirm }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {content}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
      <Button onClick={onConfirm} color="primary" autoFocus>
          Yes
        </Button>
        <Button onClick={onClose} color="primary">
          No
        </Button>
        
      </DialogActions>
    </Dialog>
  );
};